<template>
  <div class="modal fade update-product-modal" id="UpdateProductModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Editar produto</h1>
                  <button type="button" class="btn-close update-product-modal" data-bs-dismiss="modal" aria-label="Close" :disabled="galleryBusy"></button>
              </div>

              <form ref="formUpdateProduct" @submit.prevent="updateProductMethod">
                <div class="modal-body ps-30 pe-30">
                  <p>Preencha as informações abaixo para atualizar</p>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="name_product_update" class="form-label fw-medium"
                      >Nome</label
                    > 
                    <input
                      v-model="form.name"
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="name_product_update"
                      placeholder="Digite o nome"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="sku_product_update" class="form-label fw-medium"
                      >SKU</label
                    > 
                    <input
                      v-model="form.sku"
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="sku_product_update"
                      placeholder="Digite o SKU"
                      autocomplete="off"
                    />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="description_product_update" class="form-label fw-medium"
                      >Descrição</label
                    >                      
                    <textarea
                      v-model="form.description"
                      id="description_product_update"
                      type="text"
                      class="form-control shadow-none rounded-0 text-black radius-7"
                      placeholder="Digite a descrição"
                      rows="4"
                    ></textarea>
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="price_product_update" class="form-label fw-medium"
                      >Preço</label
                    > 
                    <input
                      v-model="form.price"
                      type="text"
                      @input="maskMoney"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="price_product_update"
                      placeholder="Digite o preço"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <ProductGalleryEditor v-model="productImages" @busy="galleryBusy = $event" />

                  <div class="col-12">
                    <div id="alertResponseApiUpdateProduct" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageUpdateProduct">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger update-product-modal" data-bs-dismiss="modal" :disabled="galleryBusy">Cancelar</button>
                  <button type="submit" ref="buttonUpdateProduct" class="btn btn-success" :disabled="galleryBusy">Salvar</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';
import { mapGetters } from 'vuex';
import ProductGalleryEditor from './ProductGalleryEditor.vue';
import { catalogError } from '@/services/catalog';

export default {
  name: "UpdateProductModal",
  components: { ProductGalleryEditor },
  data () {
    return {
        productImages: [],
        galleryBusy: false,
        form: {
            name: '',
            sku: '',
            description: '',
            price: ''
        }
    }
  },
  computed: {
    ...mapGetters([
      "getCurrentUpdateProduct",
    ]),
  },
  watch: {
    getCurrentUpdateProduct: {
        immediate: true,
        handler(product) {
            if (!product || !product.id) return;

            this.form.name = product.name;
            this.form.sku = product.sku;
            this.form.description = product.description;

            this.productImages = [...(product.images || [])];
            const value = Number(product.price || 0);
            this.form.price = new Intl.NumberFormat("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        }
    }
  },
  methods: {
    maskMoney(e) {
      let value = e.target.value;

      value = value.replace(/\D/g, "");

      if (!value) {
        this.form.price = "";
        return;
      }

      value = (parseInt(value, 10) / 100).toFixed(2);

      value = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);

      this.form.price = value;
    },
    updateProductMethod(){
      const alertResponse = this.alertResponse;

      const product_id = this.getCurrentUpdateProduct.id;
      
      if(!this.form.name || !this.form.price){
        this.alertResponse("Por favor preencha todos os campos obrigatórios", true);
        return;
      }

    const objProductUpdate = {
        image_ids: this.productImages.map(image => image.id),
        id: product_id,
        name: this.form.name,
        sku: this.form.sku,
        description: this.form.description,
        price: this.form.price.replace(/\./g, '').replace(',', '.')
    }

      const buttonUpdateProduct = this.$refs.buttonUpdateProduct;
      buttonUpdateProduct.disabled = true;
      buttonUpdateProduct.innerHTML = "Salvando...";
      

      api.axios.post("/api/products/update/" + product_id, objProductUpdate).catch(function(error){
        if(error.response?.data != undefined){
          buttonUpdateProduct.innerHTML = "Salvar";
        }

        alertResponse(catalogError(error), true);
        buttonUpdateProduct.disabled = false;
      }).then(function(response){
        
        if(response != undefined && response.status == 200){
          buttonUpdateProduct.innerHTML = "Informações salvas com sucesso !";
          window.location.reload();
        } else {
          buttonUpdateProduct.disabled = false;
          buttonUpdateProduct.innerHTML = "Salvar";
        }
      });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageUpdateProduct").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageUpdateProduct").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiUpdateProduct");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }
    },
  }
};
</script>
